<template>
    <div style="height: 100%">
        <van-nav-bar
            title="门店培训"
            left-text="返回"
            left-arrow
            @click-left="historyBackPath('intebotab')"
        />
        <el-container style="height: 100%">
            <el-header style="height: 20px">
                <el-form :inline="true" :model="searchParms" size="mini">
                    <el-form-item label="品牌门店">
                        <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="操作师">
                        <el-select v-model="searchParms.header" placeholder="请选择" style="width: 100%" filterable default-first-option clearable @change="headerChange">
                            <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="openAdd()" size="mini">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main>
                <el-table height="calc(100% - 3rem)" border :data="trainData" v-loadmore="loadmore" size="mini" style="text-align: center" highlight-current-row>
                    <el-table-column label="培训门店"  align="center" prop="storeid">
                        <template slot-scope="scope">
                            <div style="color: #409eff" v-for="(item,index) in scope.row.inteboTrainStores">{{item.parentname}}/{{item.storename}}</div>
                            <!--<el-tag v-for="(item,index) in scope.row.inteboTrainStores" :key="index">{{item.parentname}}/{{item.storename}}</el-tag>-->
                        </template>
                    </el-table-column>
                    <el-table-column label="培训类型"  align="center" prop="type">
                        <template slot-scope="scope">
                            <div v-if="scope.row.inteboTrain.type==1" style="color: #409eff">总部培训</div>
                            <div v-if="scope.row.inteboTrain.type==2" style="color: #409eff">下店培训</div>
                            <!--<el-tag v-if="scope.row.inteboTrain.type==1">总部培训</el-tag>
                            <el-tag v-if="scope.row.inteboTrain.type==2">下店培训</el-tag>-->
                        </template>
                    </el-table-column>
                    <el-table-column label="培训内容"  align="center" prop="content">
                        <template slot-scope="scope">
                            {{scope.row.inteboTrain.content}}
                        </template>
                    </el-table-column>
                    <el-table-column label="培训原因"  align="center" prop="reason">
                        <template slot-scope="scope">{{scope.row.inteboTrain.reason}}</template>
                    </el-table-column>
                    <el-table-column label="开始日期"  align="center" prop="fromdate">
                        <template slot-scope="scope">{{scope.row.inteboTrain.fromdate}}</template>
                    </el-table-column>
                    <el-table-column label="结束日期"  align="center" prop="todate">
                        <template slot-scope="scope">{{scope.row.inteboTrain.todate}}</template>
                    </el-table-column>
                    <el-table-column label="培训员工"  align="center" prop="staffname">
                        <template slot-scope="scope">
                            <div style="color: #409eff" v-for="(item,index) in scope.row.inteboTrainTeachers" :key="index">{{item.staffname}}/{{item.posname}}</div>
                            <!--<el-tag v-for="(item,index) in scope.row.inteboTrainTeachers" :key="index">{{item.staffname}}/{{item.posname}}</el-tag>-->
                        </template>
                    </el-table-column>
                    <el-table-column label="培训次数"  align="center" prop="staffname">
                        <template slot-scope="scope">
                            {{scope.row.inteboTrain.number}}
                        </template>
                    </el-table-column>
                    <el-table-column label="备注"  align="center" prop="remarks">
                        <template slot-scope="scope">
                            {{scope.row.inteboTrain.remarks}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"  align="center" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="openAddInteboTrain('update',scope.row)" type="text" size="small">修改</el-button>
                            <el-button @click="deleteInteboTrainById(scope.row)" type="text" style="color: red" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>
    </div>
</template>
<script>
export default {
    data() {
        return {
            trainData:[],
            curpage:1,
            inteboTrainData:[],
            staffData:[],
            searchParms:{
                parentid:"",
                storeid:"",
                header:"",
            },
            storeData:[],
            isFinite:false,
        }
    },
    created() {
        this.getInteboStaffTrain();
        this.getInteboStoreStructs();
        this.getInteboTrainByPage();
    },
    methods:{
        openAdd(){
            this.$router.push({path:'/addintebotrain'});
        },
        deleteInteboTrainById(row){
            this.$dialog.confirm({
                title: '删除',
                message: "您确定要删除培训信息吗？",
            }).then(() => {
                this.$post("intebosale/deleteInteboTrainById",{sysbillid:row.inteboTrain.sysbillid}).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000
                        });
                        this.trainData=[];
                        this.curpage=1;
                        this.getInteboTrainByPage();
                    }
                });
            });
        },
        openAddInteboTrain(type,row){
            this.$router.push({path:'/addintebotrain',query:{
                    sysbillid:row.inteboTrain.sysbillid,
                    type:type
                }});
        },
        loadmore(){
            if(this.isFinite==false){
                this.curpage++;
                this.getInteboTrainByPage();
            }
        },
        headerChange(val){
            this.isFinite=false;
            this.trainData=[];
            this.curpage=1;
            this.getInteboTrainByPage();
        },
        getInteboTrainByPage() {
            this.$post("intebosale/getInteboTrainByPage", {
                parentid: this.searchParms.parentid, storeid: this.searchParms.storeid,
                staffid: this.searchParms.header, curpage: this.curpage
            }).then(res => {
                if (res.sucess) {
                    let obj = res.object;
                    if (obj != null && obj.length > 0) {
                        for (let val of obj) {
                            this.trainData.push(val);
                        }
                    } else {
                        this.isFinite = true;
                    }
                }
            });
        },
        getInteboStaffTrain(){
            this.$post("inteboStaff/getInteboStaffTrain").then(res=>{
                if(res.sucess){
                    this.staffData=res.object;
                }
            });
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[0]){
                this.searchParms.parentid=val[0];
            }
            if(val[1]){
                this.searchParms.storeid=val[1];
            }
            this.isFinite=false;
            this.trainData=[];
            this.curpage=1;
            this.getInteboTrainByPage();
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    },

}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebotrain.vue